var map = {
	"./calendar.svg": 681,
	"./car.svg": 751,
	"./common/github.svg": 5614,
	"./common/google.svg": 5282,
	"./flask.svg": 7620,
	"./mortarboard.svg": 6960,
	"./risk.svg": 5618,
	"./schedule.svg": 7568,
	"./school.svg": 5031,
	"./user-calendar.svg": 1873
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7521;